import {ChangeDetectionStrategy, Component, input, output} from '@angular/core';
import {PluginSummary} from '../../../../../api';
import {TableModule} from 'primeng/table';
import {TranslatePipe} from '@ngx-translate/core';
import {ElciaButton} from '../../../../components/buttons/button/button';

@Component({
  selector: 'elcia-plugin-grid',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [TableModule, TranslatePipe, ElciaButton],
  templateUrl: './plugin-grid.html',
})
export class PluginGrid {
  plugins = input.required<PluginSummary[]>();
  pluginSelected = output<PluginSummary>();
  onDelete = output<PluginSummary>();

  onRowSelect(plugin: PluginSummary): void {
    this.pluginSelected.emit(plugin);
  }

  delete(event: Event, plugin: PluginSummary): void {
    event.stopPropagation();
    this.onDelete.emit(plugin);
  }
}
